$(function () {
    var waitForResendOtp = false;

    $(document).on("click", ".btn-book", function () {
        $("#store_id").val($(this).data("code"));
        $("#storelocator_name").val($(this).data("source"));
        $("#storelocator_alias").val($(this).data("alias"));
        $("#storelocator_direction").val($(this).data("direction"));

        $(".appointment-slider")
            .find("#form-heading")
            .html(
                $(this).data("title") +
                    '<p class="m-0 fw-normal">' +
                    $(this).data("alias") +
                    "</p>"
            );
        $(".appointment-slider").addClass("show");
        $("body").addClass("filter-overlay noscroll");
    });

    $(".appointment-slider .close-btn").click(function () {
        $(this).parents(".appointment-slider").removeClass("show");
        $("body").removeClass("filter-overlay noscroll");
    });

    $(".appointment-slider .date-wrapper .date-item").on("click", function () {
        $("#date").val($(this).data("date"));
        $("#alt_date").val($(this).data("alt-date"));

        // Remove 'active' class from all siblings
        $(this).siblings().removeClass("active");

        // Add 'active' class to the clicked element
        $(this).addClass("active");
    });

    $(".appointment-slider .time-wrapper .time-item").on("click", function () {
        $("#time").val($(this).data("time"));

        // Remove 'active' class from all siblings
        $(this).siblings().removeClass("active");

        // Add 'active' class to the clicked element
        $(this).addClass("active");
    });

    $(".appointment-slider .date-wrapper .date-item:first").trigger('click');
    $(".appointment-slider .time-wrapper .time-item:first").trigger('click');

    $(".appointment-slider .date-wrapper").slick({
        dots: false,
        arrows: true,
        slidesToShow: 5,
        infinite: false,
        slidesToScroll: 5
    });

    // custom validation rules
    $.validator.addMethod("validName", function(value, element) {
        return /^[a-zA-Z.\s]+$/.test(value);  // Regular expression for letters, dots, and spaces
    }, "The name can only contain letters, dots, and spaces.");

    $.validator.addMethod("validMobile", function(value, element) {
        var storeNumbers = ['9876543210', '1234567890']; // Replace with actual official store numbers
        
        // Validate that the number starts with 6, 7, 8, or 9, is 10 digits long, and is numeric
        var validPattern = /^[6-9]\d{9}$/;
    
        // Check if the number contains the same digit repeated 8, 9, or 10 times
        var repeatedDigitPattern = /(\d)\1{7,}/;
    
        // Validate the mobile number using all rules
        return this.optional(element) || (
            validPattern.test(value) &&                   // Matches the valid pattern
            !repeatedDigitPattern.test(value) &&          // No repetition of the same digit
            !storeNumbers.includes(value) &&              // Not in the list of store numbers
            value !== "9876543210"                        // Not the restricted number
        );
    }, "Please enter a valid mobile number.");

    $.validator.addMethod("validEmail", function(value, element) {
        var storeNames = ['orra']; // Add the list of store names here
    
        // Check if email domain is orra.co.in
        var domainNotOrra = !value.endsWith('@orra.co.in');
    
        // Check if email starts with 'orra' or any store names
        var startsWithOrraOrStore = value.toLowerCase().startsWith('orra') || storeNames.some(store => value.toLowerCase().startsWith(store.toLowerCase()));
    
        // Ensure no spaces at beginning, end, or between
        var noSpaces = !(/\s/.test(value));
    
        // Validate all conditions
        return (
            domainNotOrra &&                    // Domain should not be 'orra.co.in'
            !startsWithOrraOrStore &&           // Should not start with 'orra' or store names
            noSpaces                            // No spaces anywhere
        );
    }, "Please enter a valid email address.");

    $("#appointment-form").validate({
        rules: {
            first_name: {
                required: true,
                validName: true,
                minlength: 2,
            },
            last_name: {
                required: true,
                validName: true,
                minlength: 2,
            },
            phoneno: {
                required: true,
                validMobile: true,
            },
            email: {
                required: false,
                email: true,
                validEmail: true,
            },
            message: {
                required: false,
                minlength: 5,
            },
            otp: {
                required: false,
                minlength: 6,
                maxlength: 6,
            },
        },
        messages: {
            first_name: {
                required: "Please enter your first name.",
                minlength:
                    "Your first name must be at least 2 characters long.",
            },
            last_name: {
                required: "Please enter your last name.",
                minlength: "Your last name must be at least 2 characters long.",
            },
            phoneno: {
                required: "Please enter your phone number.",
                minlength: "Mobile number must be exactly 10 digits",
                maxlength: "Mobile number must be exactly 10 digits",
                digits: "Please enter a valid phone number.",
            },
            email: {
                required: "Please enter your email.",
                email: "Please enter a valid email address.",
            },
            message: {
                required: "Please enter a message.",
                minlength: "Your message must be at least 5 characters long.",
            },
        },
    });

    $("#appointment-form #phoneno").on("input", function () {
        if (waitForResendOtp === true) return false;

        if ($(this).val().length == 10) {
            $("#btnSendOtp").prop('disabled', false);
        } else {
            $("#btnSendOtp").prop('disabled', true);
        }
    });

    $("#appointment-form #btnSendOtp").on("click", function () {
        if (!$(this).hasClass("disabled") && $("#appointment-form").valid()) {

            var formData = new FormData(document.getElementById("appointment-form"));

            $.ajax({
                url: $(this).data("url"),
                type: "POST",
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (response.status == "success") {
                        showResendOtpMsg();
                        $(".submit-book-form").prop('disabled', false);
                    } else {
                        errorMessage(response.message);
                    }
                },
                error: function (reject) {
                    var message = "";

                    if (reject.status === 422) {
                        var response = $.parseJSON(reject.responseText);
                        $.each(response.errors, function (key, value) {
                            message += value[0] + "</br>";
                        });
                    } else {
                        message = reject.responseText;
                    }

                    errorMessage(message);
                },
            });
        }
    });

    $("#appointment-form").on("submit", function (e) {
        e.preventDefault();

        if ($("#appointment-form").valid()) {
            var formData = new FormData(document.getElementById("appointment-form"));

            $.ajax({
                url: $(this).data("url"),
                type: "POST",
                data: formData,
                processData: false,
                contentType: false,
                beforeSend: function(xhr) {
                    $(".submit-book-form").prop('disabled', true); // remove this before enable otp
                },
                success: function (response) {
                    if (response.status == "success") {
                        successMessage(formData);
                    } else {
                        errorMessage(response.message);
                    }

                    $(".submit-book-form").prop('disabled', false); // remove this before enable otp
                },
                error: function (reject) {
                    var message = "";

                    if (reject.status === 422) {
                        var response = $.parseJSON(reject.responseText);
                        $.each(response.errors, function (key, value) {
                            message += value[0] + "</br>";
                        });
                    } else {
                        message = reject.responseText;
                    }

                    errorMessage(message);

                    $(".submit-book-form").prop('disabled', false); // remove this before enable otp
                },
            });
        }
    });

    let countdown;

    function showResendOtpMsg() {
        $("#btnSendOtp").prop('disabled', true).parents('.mobile').removeClass('mb-3').addClass('mb-0');
        $("#otp-box").removeClass("d-none");
        $('#resendOtp').removeClass('d-none');
        
        waitForResendOtp = true;
        startTimer();

        $("#otp").rules("add", {required: true});
    }

    function hideResendOtpMsg() {
        $("#btnSendOtp").prop('disabled', true).parents('.mobile').removeClass('mb-0').addClass('mb-3');
        $("#otp-box").addClass("d-none");
        $('#resendOtp').addClass('d-none');

        waitForResendOtp = false;
        clearInterval(countdown);

        $("#appointment-form #phoneno").trigger('input');
        $("#otp").rules("remove", "required");
        $("#otp").removeClass('error');
    }

    function startTimer() {
        let timeLeft = 60; // 1 minute
        $('#resendOtp').html(`You can resend the OTP in <strong>${timeLeft}</strong> seconds.`);

        waitForResendOtp = true;
        $('#resendOtp').removeClass('d-none');

        countdown = setInterval(() => {
            timeLeft--;
            if (timeLeft <= 0) {
                hideResendOtpMsg();

            } else {
                $('#resendOtp').html(`You can resend the OTP in <strong>${timeLeft}</strong> seconds.`);
            }
        }, 1000);
    }

    function successMessage(formData) {
        $("#appointment-form #phoneno").trigger('input');
        $(".appointment-slider .close-btn").trigger('click');
        $("#otp-box").addClass("d-none");
        $(".submit-book-form").prop('disabled', true);
        $("#appointment-form").trigger("reset");

        $('#confirmationModal').find('#storeName').text(formData.get("storelocator_alias"));
        $('#confirmationModal').find('#storeDirection').prop('href', formData.get("storelocator_direction"));
        $('#confirmationModal').find('#appointmentDate').html(formData.get("alt_date"));
        $('#confirmationModal').find('#appointmentTime').html(formData.get("time"));

        hideResendOtpMsg();

        var confirmationModal = new bootstrap.Modal(document.getElementById('confirmationModal'));
        confirmationModal.show();
    }

    function errorMessage(message) {
        $('#errorModal').find('#errorDetails').html(message);

        var errorModal = new bootstrap.Modal(document.getElementById('errorModal'));
        errorModal.show();
    }
});